module.exports = __webpack_public_path__ + "img/members-expired.cc878d05.svg";